import React from 'react'
import { Tour } from 'antd'
import { TOURS_ENABLED } from '../tours-enabled'

type Props = {
  open: boolean
  onClose: () => void
  headerTarget: () => HTMLElement
  onOpenDictionary: () => void
}

export function OrdersSetupTour({ open, onClose, headerTarget, onOpenDictionary }: Props) {
  if (!TOURS_ENABLED) return null
  return (
    <Tour
      open={open}
      onClose={onClose}
      steps={[
        {
          title: 'Первичная настройка заказов',
          description:
            'Для работы с заказами нужно заполнить справочники «Признак заказа» и «Тип клиента». Открою следующий незаполненный шаг.',
          target: () => headerTarget() || document.body,
          nextButtonProps: {
            children: 'Открыть справочник',
            onClick: onOpenDictionary,
          },
        },
      ]}
    />
  )
}
